import React, {Component} from "react"
import AdyenCheckout from "@adyen/adyen-web"
import {withRouter, RouteComponentProps} from "react-router-dom"
import "@adyen/adyen-web/dist/adyen.css"

import {payByAdyenDropIn, adyenProcessPayment, adyenAdditionalDetails} from "@irati/payments/services/Payments"
import {PaymentOrder} from "@irati/types"
import env from "@irati/utils/env"
import {PRODUCTION} from "@irati/utils/constants/environment"
import {PaymentState} from "@irati/payments/enums"

interface Props extends RouteComponentProps<{urlSlug: string, sagaUuid: string}> {
  amount: number,
  paymentOrder: PaymentOrder,
  onComplete: () => Promise<any>,
  redirectReturnUrl: string
}

interface State {}

class PaymentForm extends Component<Props, State> {
  state: State = {}

  dropin = null // temp var for Adyen Drop-In component

  async componentDidMount() {
    const data = {
      amount: this.props.amount,
      enableSaveCardOption: true
    }
    // Payment order is already created in Checkout Start
    // Create Payment and get Adyen Payment Methods
    const payment = await payByAdyenDropIn(this.props.paymentOrder, data)
    const amount = {value: payment.amount, currency: payment.currency}
    const configuration = {
      paymentMethodsResponse: payment.details.paymentMethods,
      clientKey: payment.details.clientKey,
      locale: payment.details.shopperLocale,
      amount,
      environment: env.ENVIRONMENT_NAME === PRODUCTION ? "live" : "test",
      countryCode: env.ENVIRONMENT_NAME === PRODUCTION ? undefined : "GB",
      paymentMethodsConfiguration: {
        card: {
          name: "Pay by card",
          enableStoreDetails: true,
          billingAddressRequired: true,
          hasHolderName: true,
          holderNameRequired: true
        },
        paypal: {
          style: {
            color: "blue",
            shape: "pill"
          },
          blockPayPalCreditButton: true
        }
      },
      onSubmit: (state, dropIn) => this.onSubmit(state, dropIn, payment),
      onAdditionalDetails: (state) => this.onAdditionalDetails(state, payment)
    }

    const checkout = new AdyenCheckout(configuration)

    this.dropin = checkout.create("dropin", {}).mount("#dropin-container")
  }

  onSubmit = (state, dropIn, payment) => {
    const {onComplete, redirectReturnUrl} = this.props
    const paymentData = {
      ...state.data,
      returnUrl: redirectReturnUrl,
      origin: window.location.origin
    }
    // TODO review error handling when removing fake-saga implementation
    // currently, we'll always trigger the onComplete so the paymentOrder.status can be checked on the next screen
    adyenProcessPayment(this.props.paymentOrder.uuid, payment.uuid, paymentData)
      .then((response) => {
        if (response.action) {
          dropIn.handleAction(response.action)
        } else {
          onComplete({type: PaymentState.PAYMENT_COMPLETE})
        }
      })
      .catch(() => {
        onComplete({type: PaymentState.PAYMENT_COMPLETE})
      })
  }

  onAdditionalDetails = (state, payment) => {
    const {onComplete} = this.props
    adyenAdditionalDetails(this.props.paymentOrder.uuid, payment.uuid, state.data)
      .then(() => {
        onComplete({type: PaymentState.PAYMENT_COMPLETE})
      })
      .catch(() => {
        onComplete({type: PaymentState.PAYMENT_COMPLETE})
      })
  }

  render() {
    return <div id="dropin-container" />
  }
}

export default withRouter(PaymentForm)
